import { useMemo } from 'react';
import { useViewport } from '@tryhackme/thm-ui-components';
import { DetailVideoProps } from 'src/features/room/room.types';
import { useTrackEventMutation } from 'src/common/slices';
import { VideoSource } from './video.types';
import { StyledDate, StyledDetailsContainer, StyledSourceContainer, StyledTitle, StyledTitleContainer, StyledVideoContent, StyledVideoPlayback } from './video.styles';
export const Video = ({
  videoDetails,
  isTHMVideo
}: {
  videoDetails?: DetailVideoProps;
  isTHMVideo?: boolean;
}) => {
  const [trackEvent] = useTrackEventMutation();
  const {
    width: windowWidth
  } = useViewport();
  const videoPostedOn = new Date(videoDetails?.added ?? Date.now());
  const formattedVideoDate = videoPostedOn.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
  const videoHeight = useMemo(() => {
    if (windowWidth >= 360 && windowWidth < 1024) return 327;
    if (windowWidth < 360) return 154;
    return 634;
  }, [windowWidth]);
  const trackVideoPlayed = () => {
    // eslint-disable-next-line no-void
    void trackEvent({
      event: 'play-video',
      properties: {
        title: videoDetails?.title
      }
    });
  };
  return <StyledVideoContent data-sentry-element="StyledVideoContent" data-sentry-component="Video" data-sentry-source-file="video.tsx">
      <StyledDetailsContainer data-sentry-element="StyledDetailsContainer" data-sentry-source-file="video.tsx">
        <StyledTitleContainer data-sentry-element="StyledTitleContainer" data-sentry-source-file="video.tsx">
          {videoDetails?.title && <StyledTitle>
              {videoDetails?.title} • {videoDetails?.added && <StyledDate>{formattedVideoDate}</StyledDate>}
            </StyledTitle>}
        </StyledTitleContainer>
        {videoDetails?.source && <StyledSourceContainer>Source: {VideoSource[videoDetails?.source]}</StyledSourceContainer>}
      </StyledDetailsContainer>
      <StyledVideoPlayback onPlay={trackVideoPlayed} url={videoDetails?.url} height={videoHeight} controls $isTHMVideo={isTHMVideo} data-sentry-element="StyledVideoPlayback" data-sentry-source-file="video.tsx" />
    </StyledVideoContent>;
};